<script setup lang="ts">
import { useTonConnectModal } from '@townsquarelabs/ui-vue'
import {
    usePuzzlesCompletionChallengeLeaderboard,
} from '@/composables/game/leader-board'
import { usePuzzlesCompletionChallenge } from '@/composables/game/challenges'
import { useWalletConnect } from '@/composables/game/wallet-connect'
import { usePuzzles, usePuzzlesOverlay } from '@/composables/game/puzzles'
import BaseChallengeModal from '@/components/modals/BaseChallengeModal.vue'
import PuzzleChallengeIcon from '@/assets/images/puzzle-challenge-icon.webp'
import PuzzleChallengeBackgroundImage from '@/assets/images/puzzle-challenge-modal-background.webp'
import PuzzleChallengeIconWithoutShadow from '@/assets/images/puzzle-challenge-icon-no-shadow.webp'

defineProps<{
	show: boolean
}>()
const emit = defineEmits(['hide'])

const { openPuzzlesOverlay } = usePuzzlesOverlay()

const { open } = useTonConnectModal()
const { rawAddress } = useWalletConnect()
const { firstPuzzleLiveOp } = usePuzzles()
const { formattedCountdown, puzzlesCompletionChallenge } = usePuzzlesCompletionChallenge()
const {
  getPuzzlesCompletionChallengeLeaderboard,
  puzzlesCompletionChallengeLeaderboard: players,
  currentPlayer,
} = usePuzzlesCompletionChallengeLeaderboard()
</script>

<template>
  <BaseChallengeModal
    :show="show"
    :challenge="puzzlesCompletionChallenge"
    :formatted-countdown="formattedCountdown"
    :on-cta-click="openPuzzlesOverlay"
    :get-leaderboard="getPuzzlesCompletionChallengeLeaderboard"
    :players="players"
    :current-player="currentPlayer"
    background-color="bg-[linear-gradient(180deg,_#FF0533_0.01%,_#5A83A7_21.93%,_#000_36.54%)]"
    :background-image="PuzzleChallengeBackgroundImage"
    :main-image="PuzzleChallengeIcon"
    main-image-class="size-[225px] -translate-y-[100px]"
    main-image-background-class="size-[50px] bg-[#14F1FF] blur-[27px]"
    :with-stars="true"
    timer-background-class="bg-[linear-gradient(90deg,#FF0533_2.81%,#5A83A7_28.73%,#000_86.74%)]"
    title="Jigsaw challenge"
    description="Complete the most puzzles and claim rewards! Make sure to "
    cta-text="Crack Jigsaw Puzzle"
    rule-card-line1="Complete"
    rule-card-line2="Puzzles"
    :score-image="PuzzleChallengeIconWithoutShadow"
    :is-rule-card-clickable="true"
    :is-cta-disabled="!firstPuzzleLiveOp"
    @hide="emit('hide')"
  >
    <template #ruleContent>
      <div class="flex flex-col items-center gap-y-3">
        <span>How it works:</span>
        <span>
          • Complete as many
          <span
            :class="{'pointer-events-none': !!currentPlayer?.score, 'border-b border-current': !currentPlayer?.score}"
            @click="() => openPuzzlesOverlay()"
          >
            jigsaw puzzles
          </span>
          as you can to climb the leaderboard
        </span>
        <span>
          • Make sure to
          <span
            :class="{'pointer-events-none': !!rawAddress, 'border-b border-current': !rawAddress}"
            @click="open"
          >
            connect
          </span>
          your wallet to participate.
        </span>
      </div>
    </template>
  </BaseChallengeModal>
</template>
